import { loaderService } from "../../common/custom-loader/loader-service";
import { authKey, ADD_MULTIPLE_STORAGE_CAP, PAYMENT_CYCLE_LIST, FETCH_PAYMENT_DETAILS, ADD_PAYMENT_DETAILS, PAYMENT_METHOD_LIST, GROWERS_VACANT_LAND_LIST, FETCHING_ADD_STORAGE_CAPACITY, FETCHING_STORAGE_CAPACITY, GET_DROPDOWN_FOR_PLANTATION_BATCH, GET_All_STATE, GET_All_DISTRICT, GET_ALL_BLOCKLIST_AND_REVENUECIRCLE, CONFIG_MASTER_CONTROLLER, UPLOAD_DCUMENT, DOWNLOAD_DOCUMENT, ADD_UPDATE_DELETE_LOV, PAYMENT_URN_LIST, GET_GROWERS_FOR_DBS, ADD_GROWERS_FOR_DBS, FETCH_MATERIAL_LIST, ADD_MATERIAL_LIST, EDIT_MATERIAL_LIST, FETCH_BUDGET_RANGE_LIST, ADD_BUDGET_RANGE, EDIT_BUDGET_RANGE, FETCH_USER_LIST, PROVIDE_SEEK_CLARIFICATION_PLANTATION_BATCH, FETCH_AGGREGATORLIST, SAVE_AGGREGATORID, EDIT_AGGREGATORID, ADD_AGGREGATOR_HIT_MAPPING, EDIT_AGGREGATOR_HIT_MAPPING_BY_ID, FETCH_UNMAPPED_AGGREGATOR_ID_RES_LIST, FETCH_AGGREGATOR_HIT_MAPPING, FETCH_HIT_URN_LIST, FETCH_STORAGE_LOCATION, ADD_STORAGE_LOCATION, EDIT_STORAGE_LOCATION, DELETE_STORAGE_LOCATION } from '../../common/URLs';

import { getLocalStorageItem } from "../../common/localStorageUtils";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from 'uuid';
import apiClient from "../../axios";

export function getAllState(setchooseState) {
  loaderService.showLoader();
  apiClient
    .post(GET_All_STATE,
      {

      },
      {
        headers: {
          AuthKey: authKey,
        },
      }
    )
    .then((response) => {
      setchooseState(response.data.stateList);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();

    });
}

export function getAllDistrict(selectedState, setChooseDistrict) {
  loaderService.showLoader();
  apiClient
    .post(GET_All_DISTRICT,
      {
        "state": selectedState
      },
      {
        headers: {
          AuthKey: authKey,
        },
      }
    )
    .then((response) => {
      setChooseDistrict(response.data.districtLists);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function getAllRevenueCircle(selectedDistrict, setChooseRevenueCircle) {
  loaderService.showLoader();
  apiClient
    .post(GET_ALL_BLOCKLIST_AND_REVENUECIRCLE,
      {
        "district": selectedDistrict
      },
      {
        headers: {
          AuthKey: authKey,
        },
      }
    )
    .then((response) => {
      setChooseRevenueCircle(response.data?.revenueCircleAndBlockList?.revenueCircleLists);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function getCategoryList(setCategoryList) {
  loaderService.showLoader();
  apiClient
    .post(CONFIG_MASTER_CONTROLLER + `?serviceType=Stakeholder_Rate_Card`,
      {
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setCategoryList(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function getDocumentUploadDetails(selectedFile, setDocumentUploadDetails) {
  loaderService.showLoader();
  const formData = new FormData();
  formData.append("file", selectedFile);
  formData.append("fileName", selectedFile.name);
  formData.append("containerName", "resourcefiles");
  apiClient
    .post(
      UPLOAD_DCUMENT,
      formData,
      {
        headers: {
          AuthKey: authKey,
        },
      }
    )
    .then((response) => {
      setDocumentUploadDetails(response.data);
      loaderService.hideLoader();
    })

    .catch(function (error) {
      console.log(error);
      loaderService.hideLoader();
    });
}

export const viewdownloadDocument = (fileName, containerName, finalfileName) => {
  loaderService.showLoader()
  return fetch(DOWNLOAD_DOCUMENT,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        AuthKey: authKey,
      },
      body: JSON.stringify({
        "fileName": fileName,
        "containerName": containerName
      })
    })
    .then((response) => {
      return response.blob();
    })
    .then((blob) => {
      const fileName = finalfileName
      const splittedName = fileName.split('.')
      const fileExtension = splittedName[splittedName.length - 1];
      let fileType;
      switch (fileExtension) {
        case 'pdf':
          fileType = 'application/pdf';
          break;
        case 'png':
          fileType = 'image/png';
          break;
        case 'jpg':
          fileType = 'image/jpeg';
          break;
        case 'jpeg':
          fileType = 'image/jpeg';
          break;
        default:
          fileType = 'application/octet-stream';
      }
      const url = window.URL.createObjectURL(new Blob([blob], { type: fileType }));
      const newWindow = window.open(url, '_blank');
      newWindow.focus();
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log(error);
      loaderService.hideLoader();
    });
}

export const getLovValues = (setBambooSPeciesArr, setSaplingTypeArr, setSaplingSourceArr) => {
  apiClient
    .post(
      GET_DROPDOWN_FOR_PLANTATION_BATCH,
      {
      },
      {
        headers: {
          Authorization: "Bearer " + getLocalStorageItem('id_token'),
        },
      },
      null
    )
    .then((response) => {
      setBambooSPeciesArr(response.data.Bamboo_species.map((item, index) => {
        return { id: item.id, species: item?.value, type: "Existing", uniqueId: uuidv4() };
      }))
      setSaplingTypeArr(response.data.Type_of_sapling.map((item, index) => {
        return { id: item.id, saplingType: item?.value, type: "Existing", uniqueId: uuidv4() };
      }))
      setSaplingSourceArr(response.data.Source_of_sapling.map((item, index) => {
        return { id: item.id, saplingSource: item?.value, type: "Existing", uniqueId: uuidv4() };
      }))
    })
    .catch(function (error) {
      console.log(error);
    });
};

export function fetchBudgetRangeList(setBudgetRangeListArr) {
  loaderService.showLoader();
  apiClient
    .post(FETCH_BUDGET_RANGE_LIST,
      {
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      loaderService.hideLoader();
      setBudgetRangeListArr(response.data.map((item) => ({ ...item, id: item.id, type: "Existing", uniqueId: uuidv4() })))
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function addRangeList(details, setBudgetRangeListArr) {
  loaderService.showLoader();
  apiClient
    .post(ADD_BUDGET_RANGE,
      {
        "budgetRange": details?.budgetValue,
        "highestApproverRole": details?.budgetApplicationType,
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      loaderService.hideLoader();
      fetchBudgetRangeList(setBudgetRangeListArr);
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function editBudgetList(details, row, setBudgetRangeListArr) {
  loaderService.showLoader();
  apiClient
    .post(EDIT_BUDGET_RANGE,
      {
        "id": row?.id,
        "serviceType": row?.serviceType,
        "applicationKey": details?.budgetApplicationType,
        "value": details?.budgetValue,
        "isActive": "Y",
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      loaderService.hideLoader();
      fetchBudgetRangeList(setBudgetRangeListArr);
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function fetchUserList(setUserList) {
  loaderService.showLoader();
  apiClient
    .post(FETCH_USER_LIST,
      {
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      loaderService.hideLoader();
      setUserList(response.data);
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function fetchMaterialList(setMaterialListArr) {
  loaderService.showLoader();
  apiClient
    .post(FETCH_MATERIAL_LIST,
      {
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      loaderService.hideLoader();
      setMaterialListArr(response.data.map((item) => ({ ...item, id: item.id, type: "Existing", uniqueId: uuidv4() })))
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function addMaterialList(details, setMaterialListArr) {
  loaderService.showLoader();
  apiClient
    .post(ADD_MATERIAL_LIST,
      {
        "materialCode": details?.materialValue,
        "materialType": details?.materialApplicationType,
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      loaderService.hideLoader();
      fetchMaterialList(setMaterialListArr);
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function editMaterialList(details, row, setMaterialListArr) {
  loaderService.showLoader();
  apiClient
    .post(EDIT_MATERIAL_LIST,
      {
        "id": row?.id,
        "serviceType": row?.serviceType,
        "applicationKey": details?.materialApplicationType,
        "value": details?.materialValue,
        "isActive": "Y",
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      loaderService.hideLoader();
      fetchMaterialList(setMaterialListArr);
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function addUpdateDeleteLov(serviceType, value, applicationType, action, id, setLovResponse, setBambooSPeciesArr, setSaplingTypeArr, setSaplingSourceArr) {
  loaderService.showLoader();
  apiClient
    .post(ADD_UPDATE_DELETE_LOV,
      {
        "serviceType": serviceType,
        "value": value,
        "applicationType": applicationType,
        "action": action,
        "id": id
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setLovResponse(response.data);
      getLovValues(setBambooSPeciesArr, setSaplingTypeArr, setSaplingSourceArr);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function growersDbsList(details, setGrowersList, setGrowersListOld) {
  loaderService.showLoader();
  apiClient
    .post(GET_GROWERS_FOR_DBS,
      {
        "category": "Grower",
        "state": details?.state,
        "district": details?.district,
        "revenueCircle": details?.revenueCircle,
        "hitMapped": details?.hitMapped
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      let arrayData = []
      response?.data?.map((item) => {
        item?.growerDbsResponse?.map((landItem) => arrayData.push({
          ...landItem,
          name: item?.name,
          urn: item?.urn,
          growerType: item?.category,
          type: "notChanged"
        }))
      })
      setGrowersList([...arrayData])
      setGrowersListOld([...arrayData.map(item => ({ ...item }))])
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function addGrowersDbs(addGrowersArray, setSelectedRows, setDbsFlag, setResponse) {
  loaderService.showLoader();
  apiClient
    .post(ADD_GROWERS_FOR_DBS,
      {
        "growerDbsReqstPojo": addGrowersArray
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      loaderService.hideLoader();
      if (response.data.status === "SUCCESS") {
        setResponse(response.data)
        toast.success(response.data.description)
        setSelectedRows([]);
        setDbsFlag("");
        // navigate('/resourcedashboard/home');
        // growersDbsList(details, setGrowersList, setGrowersListOld);
      }
      else if (response.data.status === "FAILURE") toast.error(response.data.description)
      else toast.error("Something went wrong, Please try again!")
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function growersVacantLandList(details, setGrowersList) {
  loaderService.showLoader();
  apiClient
    .post(GROWERS_VACANT_LAND_LIST,
      {
        "category": "Grower",
        "state": details?.state,
        "district": details?.district,
        "revenueCircle": details?.revenueCircle
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      let arrayData = []
      response?.data?.map((item) => {
        item?.landDtlList?.map((landItem) => arrayData.push({
          ...landItem,
          name: item?.name,
          urn: item?.urn,
          growerType: item?.growerType,
          isApprovedGrower: item.isApprovedGrower
        }))
      })
      setGrowersList(arrayData)
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}
export function fetchingStorageCapacity(setFetchLLEISCapacity) {
  loaderService.showLoader();
  apiClient
    .post(FETCHING_STORAGE_CAPACITY,
      {

      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        },
      }
    )
    .then((response) => {
      setFetchLLEISCapacity(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();

    });
}

export function fetchingNewStorageCapacity(setNewLLEISCapacity) {
  loaderService.showLoader();
  apiClient
    .post(FETCHING_ADD_STORAGE_CAPACITY,
      {

      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        },
      }
    )
    .then((response) => {
      setNewLLEISCapacity(response.data.stakeHolders);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();

    });
}

export function updatemaxCapFactor(arr, setSuccessSaveCapacity, setArr) {
  loaderService.showLoader();
  apiClient
    .post(ADD_MULTIPLE_STORAGE_CAP,
      {
        "getlLEIsStorageEntity": arr
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        },
      }
    )
    .then((response) => {
      setSuccessSaveCapacity(response.data);
      setArr([])
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();

    });
}

export function getPaymentUrnsList(setUrnsList, rateCardDetails, setPaymentDetailsList) {
  loaderService.showLoader();
  apiClient
    .post(PAYMENT_URN_LIST,
      {
        "category": rateCardDetails?.category,
        "state": rateCardDetails?.state,
        "district": rateCardDetails?.district,
        "revenueCircle": rateCardDetails?.revenueCircle
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setUrnsList(response.data);
      getPaymentDetailsList(rateCardDetails?.category, response.data.map((item) => ({ urn: item.urn, landList: item.categoryName === "Grower" ? item.landDtlList.map((landItem) => ({ landId: landItem.landId })) : null })), setPaymentDetailsList)
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function getPaymentDetailsList(category, urnsArr, setPaymentDetailsList) {
  loaderService.showLoader();
  apiClient
    .post(FETCH_PAYMENT_DETAILS,
      {
        "categoryName": category,
        "urnListPojo": urnsArr
      },
      {
        headers: {
          AuthKey: authKey,
        }
      }, null
    )
    .then((response) => {
      setPaymentDetailsList(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function addPaymentDetails(finalArray, setAddedResponse) {
  loaderService.showLoader();
  apiClient
    .post(ADD_PAYMENT_DETAILS,
      {
        "paymentReqstList": finalArray
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setAddedResponse(response.data);
      if (response.data.status === "SUCCESS") {
        toast.success(response.data.description);
        // navigate('/resourcedashboard/home');
      }
      else toast.error(response.data.description)
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function getPaymentMethodList(setPaymentMethodList) {
  loaderService.showLoader();
  apiClient
    .post(PAYMENT_METHOD_LIST,
      {
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setPaymentMethodList(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function getPaymentCycleList(setPaymentCycleList) {
  loaderService.showLoader();
  apiClient
    .post(PAYMENT_CYCLE_LIST,
      {
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setPaymentCycleList(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function provideSeekClarificationPlantationBatch(sponosoreDetails, speciesDetails, setProvideClarificationResponse) {
  loaderService.showLoader();
  apiClient
    .post(PROVIDE_SEEK_CLARIFICATION_PLANTATION_BATCH,
      {
        id: sponosoreDetails?.id,
        sponsoredDocument: sponosoreDetails?.sponsoredDocument,
        sponsoredDocumentGuid: sponosoreDetails?.sponsoredDocumentGuid,
        documentContainerName: sponosoreDetails?.documentContainerName,
        species: [speciesDetails]
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setProvideClarificationResponse(response.data.respStts);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function fetchAggregatorList(setAggregatorArr) {
  loaderService.showLoader();
  apiClient
    .post(FETCH_AGGREGATORLIST,
      {
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      loaderService.hideLoader();
      setAggregatorArr(response.data.map((item) => ({ ...item, id: item.id, type: "Existing", uniqueId: uuidv4() })))
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function addAggregatorList(details, setAggregatorArr) {
  loaderService.showLoader();
  apiClient
    .post(SAVE_AGGREGATORID,
      {
        "aggregatorId": details?.aggregatorValue,
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      loaderService.hideLoader();
      fetchAggregatorList(setAggregatorArr);
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function editAggregatorList(details, row, setAggregatorArr) {
  loaderService.showLoader();
  apiClient
    .post(EDIT_AGGREGATORID,
      {
        "id": row?.id,
        "serviceType": row?.serviceType,
        "applicationKey": details?.aggregatorApplicationType,
        "value": details?.aggregatorValue,
        "isActive": "Y",
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      loaderService.hideLoader();
      fetchAggregatorList(setAggregatorArr);
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function getListOfHit (setHitList) {
  loaderService.showLoader();
  apiClient
      .post(
          FETCH_HIT_URN_LIST,
          {
              "type": "HIT"
          },
          {
              headers: {
                  Authorization: "Bearer " + getLocalStorageItem("id_token"),
              },
          },
          null
      )
      .then((response) => {
          loaderService.hideLoader();
          setHitList(response.data.stakeHolders)
      })
      .catch(function (error) {
          console.log(error);
          loaderService.hideLoader();
      });
};

  export function getUnmappedAggregatorList (setUmappedAggregatorList) {
        loaderService.showLoader();
        apiClient
            .post(
                FETCH_UNMAPPED_AGGREGATOR_ID_RES_LIST,
                {},
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem("id_token"),
                    },
                },
                null
            )
            .then((response) => {
                loaderService.hideLoader();
                setUmappedAggregatorList(response.data.aggregatorIdResp)
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
            });
    };

export function fetchAggregatorHitMappingList(setAggregatorHITMappingArr) {
  loaderService.showLoader();
  apiClient
    .post(FETCH_AGGREGATOR_HIT_MAPPING,
      {
      },
      {
        headers: {
          AuthKey: authKey,
        }
      }, null
    )
    .then((response) => {
      loaderService.hideLoader();
      setAggregatorHITMappingArr(response.data.aggregatorHitInputReqst.map((item) => ({ ...item, id: item.id, type: "Existing", uniqueId: uuidv4() })))
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function addAggregatorHitMappingList(details, setAggregatorHITMappingArr, setHitList, setUmappedAggregatorList, setResponse) {
  let hit = details?.hitUrn.split('(')
  loaderService.showLoader();
  apiClient
    .post(ADD_AGGREGATOR_HIT_MAPPING,
      {
        "hitUrn": hit[0],
        "hitName": hit[1]?.slice(0, -1),
        "aggregatorId": details?.aggregatorId
      },
      {
        headers: {
          AuthKey: authKey,
        }
      }, null
    )
    .then((response) => {
      loaderService.hideLoader();
      fetchAggregatorHitMappingList(setAggregatorHITMappingArr);
      getListOfHit(setHitList);
      getUnmappedAggregatorList(setUmappedAggregatorList);
      setResponse(response.data)
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function editAggregatorHitMappingList(details, row, setAggregatorHITMappingArr, setHitList, setUmappedAggregatorList, setResponse) {
  let hit = details?.hitUrn.split('(')
  loaderService.showLoader();
  apiClient
    .post(EDIT_AGGREGATOR_HIT_MAPPING_BY_ID,
      {
        "id": row?.id,
        "hitUrn": hit[0],
        "hitName": hit[1]?.slice(0, -1),
        "aggregatorId": details?.aggregatorId,
        "isActive": "Y",
      },
      {
        headers: {
          AuthKey: authKey,
        }
      }, null
    )
    .then((response) => {
      loaderService.hideLoader();
      fetchAggregatorHitMappingList(setAggregatorHITMappingArr);
      getListOfHit(setHitList);
      getUnmappedAggregatorList(setUmappedAggregatorList);
      setResponse(response.data)
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function fetchStorageLocation(setStorageLocationListArr) {
  loaderService.showLoader();
  apiClient
    .post(FETCH_STORAGE_LOCATION, {}, {
      headers: {
        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
      }
    })
    .then((response) => {
      const rawList = response.data?.storageLocation;
      const dataToSet = Array.isArray(rawList) ? rawList : [];
      
      setStorageLocationListArr(dataToSet);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      setStorageLocationListArr([]);
      loaderService.hideLoader();
    });
}

export function addStorageLocation(payload, setStorageLocationListArr) {
  loaderService.showLoader();
  apiClient
    .post(ADD_STORAGE_LOCATION, 
      payload, 
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }
    )
    .then((response) => {
      // Re-fetch the updated list to sync DataGrid seamlessly
      fetchStorageLocation(setStorageLocationListArr);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function editStorageLocation(payload, setStorageLocationListArr) {
  loaderService.showLoader();
  apiClient
    .post(EDIT_STORAGE_LOCATION, 
      payload, 
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }
    )
    .then((response) => {
      // Re-fetch the updated list to refresh grid states
      fetchStorageLocation(setStorageLocationListArr);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function deleteStorageLocation(payload, setStorageLocationListArr) {
  loaderService.showLoader();
  apiClient
    .post(DELETE_STORAGE_LOCATION, 
      payload, 
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }
    )
    .then((response) => {
      // Re-fetch list to drop the deleted row from UI
      fetchStorageLocation(setStorageLocationListArr);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}
